import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from './Sidebar';
import ChangePasswordModal from './ChangePasswordModal';

/* ===========================================================================
 * ClientLayout — configura o componente genérico <Sidebar> pro painel do
 * cliente (itens de navegação, chip de créditos, modal de alterar senha).
 * ========================================================================= */

const ClientLayout = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  const credits = user?.credits ?? 0;
  const creditsClass = credits === 0 ? 'empty' : credits < 10 ? 'low' : '';

  const navItems = [
    { to: '/dashboard', icon: 'fa-gauge', label: 'Dashboard', end: true },
    { to: '/generate-code', icon: 'fa-barcode', label: 'Gerar código' },
    { to: '/buy-credits', icon: 'fa-coins', label: 'Comprar créditos' },
    { to: '/my-codes', icon: 'fa-list-check', label: 'Meus códigos' },
    {
      label: 'Integrações', icon: 'fa-plug',
      // Novas integrações (checkouts + notificações) entram aqui, uma por item.
      children: [
        { to: '/integrations/shopify', icon: 'fa-shopify', iconLib: 'fab', label: 'Shopify' },
        { to: '/integrations/checkouts', icon: 'fa-plug', label: 'Checkouts' },
        { to: '/integrations/notifications', icon: 'fa-paper-plane', label: 'Automações' },
      ],
    },
  ];

  if (user?.isAdmin) {
    navItems.push({ to: '/admin', icon: 'fa-user-shield', label: 'Painel Admin', variant: 'variant-top' });
  }

  const creditsChip = (
    <button className={`sb-credits-chip ${creditsClass}`} onClick={() => navigate('/buy-credits')} title="Comprar créditos">
      <i className="fas fa-coins"></i>
      <div>
        <span className="sb-credits-chip-label">Créditos</span>
        <span className="sb-credits-chip-val">{credits}</span>
      </div>
    </button>
  );

  const topbarCredits = (
    <button className={`sb-topbar-credits ${credits === 0 ? 'empty' : ''}`} onClick={() => navigate('/buy-credits')} title="Comprar créditos">
      <i className="fas fa-coins"></i> {credits}
    </button>
  );

  return (
    <>
      <Sidebar
        brandIcon="fa-box-open"
        brandText="COMEX"
        navItems={navItems}
        footerExtra={creditsChip}
        footerButtons={[{ icon: 'fa-key', label: 'Alterar senha', onClick: () => setShowPasswordModal(true) }]}
        topbarExtra={topbarCredits}
        onLogout={() => { logout(); navigate('/login'); }}
      />
      {showPasswordModal && <ChangePasswordModal onClose={() => setShowPasswordModal(false)} />}
    </>
  );
};

export default ClientLayout;
